<template>
  <div>
    <Edit :createDialog="createDialog" @close="close" @updated="updated" :Ticket="ticket"> </Edit>
    <v-layout
      class="mt-5"
      v-if="isLoading"
      align-center="align-center"
      justify-center="justify-center"
      column="column"
      fill-height="fill-height"
    >
      <v-progress-circular size="70" width="7" color="purple" indeterminate="indeterminate">
      </v-progress-circular>
      <div>Loading...</div>
    </v-layout>
    <div v-if="!isLoading">
      <v-toolbar class="elevation-0" color="info" dark="dark">
        <v-toolbar-title>
          <v-icon class="mr-1" medium="medium">local_offer</v-icon>
          <span>{{ ticket.id }} - {{ ticket.title }}</span>
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <TimeClock :timeZoneId="ticket.Store.timeZoneId"> </TimeClock>
        <v-menu bottom="bottom" left="left" offset-y="offset-y">
          <v-btn slot="activator" icon="icon">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list class="menu-button">
            <v-list-tile @click="edit">
              <v-list-tile-avatar>
                <v-icon>edit</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.edit") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="openActivity">
              <v-list-tile-avatar>
                <v-icon>delete</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.delete") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider> </v-divider>
            <v-list-tile @click="openActivity">
              <v-list-tile-avatar>
                <v-icon>insert_comment</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t("buttons.activity") }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-card class="border-r-0">
        <v-card-title class="pt-0">
          <v-layout column="column">
            <v-form>
              <v-container fluid="fluid">
                <v-layout
                  row
                  wrap
                  align-center="align-center"
                  justify-start="justify-start"
                  fill-height="fill-height"
                >
                  <v-flex xs12="xs12" sm3="sm3">
                    <v-select
                      v-model="ticket.statusID"
                      :items="comboBoxByID(6).ComboBoxDetails"
                      :label="$t('labels.status')"
                      item-text="selector"
                      item-value="id"
                      @change="updateStatus"
                      attach="attach"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12="xs12" sm3="sm3">
                    <v-autocomplete
                      v-model="ticket.assignedToUserID"
                      @change="updateAssigned"
                      :items="AssignedUser"
                      item-text="fullName"
                      item-value="userID"
                      :label="$t('labels.assignedTo')"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12="xs12" sm3="sm3">
                    <VueCtkDateTimePicker
                      v-model="ticketDueDate"
                      overlay="overlay"
                      :noClearButton="true"
                      label="Follow Up"
                      @validate="setDateTime"
                    >
                    </VueCtkDateTimePicker>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-container fluid="fluid" grid-list-lg="grid-list-lg">
        <v-layout row wrap>
          <v-flex xs12="xs12" sm4="sm4">
            <v-layout column="column">
              <v-flex>
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.storeInformation") }}</h1>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout column="column">
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.cspid") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="openStore">{{ store.CSPID }}</a>
                          <v-tooltip class="ml-1 pointer" bottom="bottom">
                            <template slot="activator">
                              <v-icon color="info" small="small" dark="dark" @click="openWithIcon"
                                >open_in_new</v-icon
                              >
                            </template>
                            <span>Open in new tab</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.storeName") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="openStore">{{ store.businessName }}</a>
                          <v-tooltip class="ml-1 pointer" bottom="bottom">
                            <template slot="activator">
                              <v-icon color="info" small="small" dark="dark" @click="openWithIcon"
                                >open_in_new</v-icon
                              >
                            </template>
                            <span>Open in new tab</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.phoneNumber") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          store.businessPhone
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.emailAddress") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="sendEmail(store.businessEmail)">{{ store.businessEmail }}</a>
                        </v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.currentVersion") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          store.softwareCurrentVersion
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.versionLimit") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          store.UpdateSoftwareVersion
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.lastUsed") }} </v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right"
                          >{{ store.AttandanceDateTime | moment("MM-DD-YYYY") }} |
                          {{ store.AttandanceDateTime | moment("from", "now") }}</v-flex
                        >
                      </v-layout>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex>
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.source") }}</h1>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout column="column">
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.createdAt") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.createdAt | moment("M/D/YYYY h:m a")
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.callerName") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{ ticket.name }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.phoneNumber") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.phoneNumber
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.email") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">
                          <a @click="sendEmail(ticket.email)">{{ ticket.email }}</a>
                        </v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap v-if="ticket.softwareID">
                        <v-flex>{{ $t("labels.software") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.softwareDetail.selector
                        }}</v-flex>
                      </v-layout>
                      <div v-if="ticket.softwareID === 54">
                        <v-divider> </v-divider>
                        <v-layout row wrap>
                          <v-flex>Dropbox Status</v-flex>
                          <v-spacer> </v-spacer>
                          <v-flex class="font-weight-regular text-xs-right"
                            ><div v-if="!ticket.dropbox">
                              <v-icon small color="red">close</v-icon>
                            </div>
                            <div v-else><v-icon color="green">mdi-check</v-icon></div>
                          </v-flex>
                        </v-layout>
                        <v-divider> </v-divider>
                        <v-layout row wrap>
                          <v-flex>Enter Version</v-flex>
                          <v-spacer> </v-spacer>
                          <v-flex class="font-weight-regular text-xs-right">
                            <div v-if="ticket.version">{{ ticket.version }}</div>
                            <div v-else>N/A</div>
                          </v-flex>
                        </v-layout>
                      </div>

                      <v-divider v-if="ticket.softwareID"> </v-divider>
                      <v-layout row wrap v-if="ticket.languageID">
                        <v-flex>{{ $t("labels.language") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.languageDetail.selector
                        }}</v-flex>
                      </v-layout>
                      <v-divider v-if="ticket.languageID"> </v-divider>
                      <v-layout row wrap v-if="ticket.priorityID">
                        <v-flex>{{ $t("labels.priority") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.priorityDetail.selector
                        }}</v-flex>
                      </v-layout>
                      <v-divider v-if="ticket.priorityID"> </v-divider>
                      <v-layout row wrap v-if="ticket.ticketTypeID">
                        <v-flex>{{ $t("labels.ticketType") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right"
                          >{{ ticket.ticketTypeDetail.selector }}
                        </v-flex>
                      </v-layout>
                      <v-divider v-if="ticket.ticketTypeID"> </v-divider>
                      <v-layout row wrap v-if="ticket.sourceID">
                        <v-flex>{{ $t("labels.source") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.sourceDetail.selector
                        }}</v-flex>
                      </v-layout>
                      <v-divider v-if="ticket.sourceID"> </v-divider>
                      <v-layout row wrap>
                        <v-flex>{{ $t("labels.createdBy") }}</v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="font-weight-regular text-xs-right">{{
                          ticket.reporterUser.fullName
                        }}</v-flex>
                      </v-layout>
                      <v-divider> </v-divider>
                      <v-layout row wrap>
                        <v-flex>
                          <span>{{ $t("labels.rating") }} </span>
                          <span v-if="ticket.rating == 0">Waiting</span>
                          <span v-else="v-else">- {{ ticket.rating }}</span>
                        </v-flex>
                        <v-spacer> </v-spacer>
                        <v-flex class="text-xs-right">
                          <Rating :rating="ticket.rating"> </Rating>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12="xs12" sm8="sm8">
            <v-layout row wrap>
              <v-flex xs12="xs12" sm6="sm6">
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.description") }}</h1>
                    </v-toolbar-title>
                    <v-spacer> </v-spacer>
                    <v-btn
                      small="small"
                      color="info"
                      dark="dark"
                      icon="icon"
                      @click="updateDescription"
                    >
                      <v-icon small="small">save </v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-textarea v-model="ticket.description"> </v-textarea>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12="xs12" sm6="sm6">
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.solution") }}</h1>
                    </v-toolbar-title>
                    <v-spacer> </v-spacer>
                    <v-btn
                      small="small"
                      :disabled="ticket.statusID !== 50"
                      color="info"
                      dark="dark"
                      icon="icon"
                      @click="updateSolution"
                    >
                      <v-icon small="small">save </v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-card-text>
                    <v-textarea :disabled="ticket.statusID !== 50" v-model="ticket.solution">
                    </v-textarea>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12="xs12" v-if="ticket.feedback">
                <v-card>
                  <v-toolbar class="elevation-0" height="45" color="gray">
                    <v-toolbar-title>
                      <h1 class="subheading">{{ $t("labels.feedback") }}</h1>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-card-text>
                    <v-textarea readonly="readonly" v-model="ticket.feedback"> </v-textarea>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12="xs12">
                <CommentList
                  :refID="ticket.id"
                  :ownerID="this.ticket.assignedToUserID"
                  typeId="3"
                  @commentCreated="commentCreated"
                >
                </CommentList>
              </v-flex>
            </v-layout>
            <Activity
              :activityDialog="activityDialog"
              @close="closeActivity"
              :refID="ticket.id"
              typeId="3"
            >
            </Activity>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import ticketService from "../service.js";
import CommentList from "../../Comment/components/List";
import TimeClock from "../../Global/components/TimeClock";
import DateTimePicker from "../../Global/components/DateTimePicker";
import Edit from "../components/Edit";
import Rating from "../components/TicketRateIcon";
import userService from "../../User/service.js";
import notificationService from "../../Layout/service.js";
import Activity from "../../Comment/components/ActivityDialog";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ticket-view-profile",
  data() {
    return {
      ticketDueDate: null,
      createDialog: false,
      dueDatePicker: {
        showTime: false,
        dialog: false,
        date: null,
        initDate: null,
        time: null
      },
      selectedAssignedUser: null,
      AssignedUser: [],
      assignedLoading: false,
      activityDialog: false,
      ticket: null,
      isLoading: true,
      store: null
    };
  },
  async created() {
    await this.loadEveryThing();
  },
  components: {
    Edit,
    CommentList,
    Rating,
    TimeClock,
    DateTimePicker,
    VueCtkDateTimePicker,
    Activity
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadEveryThing();
      }
    }
  },
  computed: {
    ...mapGetters("global", ["comboBox", "ComboBox", "comboBoxByID", "currentUser"]),
    dueDateFormatted() {
      let tempDate = null;
      let tempTime = null;
      if (this.dueDatePicker.date) {
        tempDate = this.$moment(this.dueDatePicker.date).format("MM/DD/YYYY");
      }

      if (this.dueDatePicker.time) {
        tempTime = this.dueDatePicker.time;
      } else {
        tempTime = this.$moment(this.dueDatePicker.initDate).format("h:m a");
      }
      return this.$moment(`${tempDate} ${tempTime}`).format("MM/DD/YYYY h:m a");
      // return null
    }
  },
  methods: {
    ...mapActions("global", ["setPageTitle", "sendEmail"]),
    async loadEveryThing() {
      await this.getAllUsers();
      await this.loadTicket();
      this.setPageTitle(this.store.CSPID + " - " + this.ticket.title + "- Ticket");
    },
    commentCreated(val) {
      console.log("sending notification");
      notificationService.setNotification({
        heading: "New Comment",
        body: `Comment was left on your ticket # ${this.ticket.id} by `,
        comment: val,
        forUserID: this.ticket.assignedToUserID,
        forUserName: this.selectedAssignedUser.fullName,
        link: `tickets/profile/${this.ticket.id}`,
        fromID: this.ticket.id,
        typeID: 3,
        from: "comment",
        label: "ticket",
        emailAddress: this.selectedAssignedUser.loginEmail,
        fromUserID: this.currentUser.userID,
        fromUserName: this.currentUser.fullName
      });
      if (this.ticket.reporterUserID !== this.currentUser.userID) {
        notificationService.setNotification({
          heading: "New Comment",
          body: `Comment was left for you on ticket # ${this.ticket.id} by `,
          comment: val,
          forUserID: this.ticket.reporterUserID,
          forUserName: this.ticket.reporterUser.fullName,
          link: `tickets/profile/${this.ticket.id}`,
          fromID: this.ticket.id,
          typeID: 3,
          from: "tickets",
          label: "ticket",
          emailAddress: this.ticket.reporterUser.loginEmail,
          fromUserID: this.currentUser.userID,
          fromUserName: this.currentUser.fullName
        });
      }
    },
    updateStatus() {
      this.AssignedUser.map(row => {
        if (row.userID === this.ticket.assignedToUserID) this.selectedAssignedUser = row;
      });
      this.update({
        statusID: this.ticket.statusID
      });
      if (this.currentUser.userID !== this.ticket.assignedToUserID) {
        notificationService.setNotification({
          heading: "Ticket",
          body: `Ticket # ${this.ticket.id} status was changed by `,
          forUserID: this.ticket.assignedToUserID,
          forUserName: this.selectedAssignedUser.fullName,
          link: `tickets/profile/${this.ticket.id}`,
          fromID: this.ticket.id,
          from: "status",
          label: "ticket",
          typeID: 3,
          emailAddress: this.selectedAssignedUser.loginEmail,
          fromUserID: this.currentUser.userID,
          fromUserName: this.currentUser.fullName
        });
      }
    },
    updateAssigned() {
      this.AssignedUser.map(row => {
        if (row.userID === this.ticket.assignedToUserID) this.selectedAssignedUser = row;
      });
      this.update({
        assignedToUserID: this.ticket.assignedToUserID
      });
      notificationService.setNotification({
        heading: "Ticket",
        body: `Ticket # ${this.ticket.id} was assigned to you by `,
        forUserID: this.ticket.assignedToUserID,
        forUserName: this.selectedAssignedUser.fullName,
        link: `tickets/profile/${this.ticket.id}`,
        fromID: this.ticket.id,
        from: "assigned",
        label: "ticket",
        typeID: 3,
        emailAddress: this.selectedAssignedUser.loginEmail,
        fromUserID: this.currentUser.userID,
        fromUserName: this.currentUser.fullName
      });
    },
    update(data) {
      delete this.ticket.dueDate;
      delete this.ticket.rating;
      return ticketService
        .update(this.ticket.id, data)
        .then(result => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              })
              .fire({
                type: "success",
                title: "Ticket was updated"
              });
          }
        })
        .catch(err => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "error",
              title: err.data.data
            });
        });
    },
    updateDescription() {
      this.update({
        description: this.ticket.description
      });
    },
    updateSolution() {
      this.update({
        solution: this.ticket.solution
      });
    },
    updated() {
      this.close();
    },
    close() {
      this.createDialog = false;
    },
    edit() {
      this.createDialog = true;
    },
    async setDateTime(val) {
      const { value: text } = await this.$swal.fire({
        title: "Reason",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true
      });
      if (text) {
        let data = {
          dueDate: this.$moment(this.ticketDueDate).toISOString(),
          changeReason: text
        };
        this.update(data);
      } else {
        // if (this.$refs) this.$refs.dateTimePicker.reset()
        this.ticketDueDate = this.$moment(this.ticket.dueDate);
      }
    },
    openStore() {
      this.$router.push({ path: `/location/profile/${this.store.storeID}` });
    },
    openWithIcon() {
      let routeData = this.$router.resolve({ path: `/location/profile/${this.store.storeID}` });
      window.open(routeData.href, "_blank");
    },
    openActivity() {
      this.activityDialog = true;
    },
    closeActivity() {
      this.activityDialog = false;
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.AssignedUser = result.data;
        this.assignedLoading = false;
      });
    },
    loadTicket() {
      if (!this.$route.params || !this.$route.params.id) return this.$router.push("/location");
      const id = this.$route.params.id;
      this.$Progress.start();
      return ticketService.getById(id).then(response => {
        console.log("ticket response", response);
        this.$Progress.finish();
        this.ticket = response.data;
        this.store = response.data.Store;
        this.ticketDueDate = this.$moment(this.ticket.dueDate);
        this.AssignedUser.map(row => {
          if (row.userID === this.ticket.assignedToUserID) this.selectedAssignedUser = row;
        });
        this.isLoading = false;
      });

      this.$Progress.finish();
    }
  }
};
</script>

<style scoped></style>
